const allowedDocExtensions = [".pdf", ".doc", ".docx"];
const allowedDoctyeps = [
	"application/pdf",
	"application/msword",
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export { allowedDocExtensions, allowedDoctyeps };
